import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const Section = ({ id, title, children, open, onToggle }) => (
  <div className="border-b border-[var(--sand)]">
    <button
      type="button"
      onClick={onToggle}
      data-testid={`pdp-details-${id}-toggle`}
      className="w-full flex items-center justify-between py-4 text-xs tracking-[0.2em] uppercase text-[var(--espresso)] hover:text-[var(--copper)] transition-colors"
    >
      {title}
      {open ? <Minus className="w-3.5 h-3.5" strokeWidth={1.25} /> : <Plus className="w-3.5 h-3.5" strokeWidth={1.25} />}
    </button>
    {open && (
      <div data-testid={`pdp-details-${id}-content`} className="pb-5 text-sm text-[var(--espresso)]/70 leading-relaxed">
        {children}
      </div>
    )}
  </div>
);

const splitSpecs = (s) => s.split("·").map((x) => x.trim()).filter(Boolean);

export const ProductDetails = ({ product }) => {
  const [open, setOpen] = useState("electrical");
  const toggle = (k) => setOpen((v) => (v === k ? null : k));
  const sections = [
    product.electrical && {
      id: "electrical", title: "Electrical",
      body: <ul className="space-y-1.5">{splitSpecs(product.electrical).map((x) => <li key={x}>— {x}</li>)}</ul>,
    },
    product.material_notes && { id: "material", title: "About PLA", body: <p>{product.material_notes}</p> },
    product.weight && { id: "weight", title: "Weight", body: <p>{product.weight}</p> },
    product.care && { id: "care", title: "Care", body: <p>{product.care}</p> },
  ].filter(Boolean);
  if (!sections.length) return null;
  return (
    <div data-testid="pdp-details" className="mt-10 border-t border-[var(--sand)]">
      {sections.map((s) => (
        <Section key={s.id} id={s.id} title={s.title} open={open === s.id} onToggle={() => toggle(s.id)}>
          {s.body}
        </Section>
      ))}
    </div>
  );
};
